<div class="home-container">

    <div class="headerWrap" >
<div class="home-frame">
<div class="status-bar" *ngFor="let desc of alertDescriptions">
<div class="status-bar-item">
  <div class="status-bar-item-label">{{desc}}</div>
  <div class="status-bar-item-value">{{openBucketTotals[desc]}}</div>
</div>
</div>
<div class="status-bar">
<div class="status-bar-item">
  <div class="status-bar-item-label">Closed</div>
  <div class="status-bar-item-value">{{zeroAsDash(smryByYear?.closedCt?.ct)}}</div>
</div>
</div>
<div class="status-bar">
<div class="status-bar-item">
  <div class="status-bar-item-label">Deferred</div>
  <div class="status-bar-item-value">{{zeroAsDash(smryByYear?.deferredCt?.ct)}}</div>
</div>
</div>
<div class="status-bar-total">
<div class="status-bar-item">
  <div class="status-bar-item-label">Total Status</div>
  <div class="status-bar-item-value">{{smryByYear?.totalCt?.ct}}</div>
</div>
</div>
<div class="status-bar">
<div class="status-bar-item">
  <div class="status-bar-item-label">Total Reports</div>
  <div class="status-bar-item-value">{{smryResponse?.reports?.length}}</div>
</div>
</div>
</div>
</div>
<div class="grid-container">
<div class="selection-container">  
<mat-form-field appearance="outline" class="dropdown-header">
  <mat-label>Select Year</mat-label>
  <mat-select [(ngModel)]="selectedValue" (selectionChange)="onYearChange()" class="dropdown-label">
    <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
  </mat-select>
</mat-form-field>
  <div class="actions-group">
  <mat-button-toggle-group [(value)]="viewType" (change)="onViewTypeChange($event.value)" class="toggle-div">  
    <mat-button-toggle class="toggle-button" value="reporttype">
      <span class="button-text" [class.button-text-active]="viewType === 'reporttype'">By Report Type</span>
    </mat-button-toggle>
    <mat-button-toggle class="toggle-button" value="month" >
      <span class="button-text" [class.button-text-active]="viewType === 'month'">By Month</span>
    </mat-button-toggle>
</mat-button-toggle-group>
<button type="button" class="export-button" *ngIf="canExport" (click)="exportToExcel()" title="Export to Excel">
  <object data="assets/img/rc-btn-secondary-icons8-excel.svg" class="rc-btn-secondary-icons8-excel" type="image/svg+xml"></object><span>Export to Excel</span>
</button>
  </div>
</div>
<div *ngIf="viewType === 'month'; else typeView">
  <app-report-view-by-month [summaryResponse]="smryByYear" [selectedYear]="selectedValue" [alertDescriptions]="alertDescriptions" [alertColorMap]="alertColorMap" [reportRole]="loggedInUser?.role || ''" [reportTypes]="reportTypes"></app-report-view-by-month>
</div>
<ng-template #typeView>
  <app-report-view-by-type [summaryResponse]="smryByRptType" [selectedYear]="selectedValue" [alertDescriptions]="alertDescriptions" [alertColorMap]="alertColorMap" [reportRole]="loggedInUser?.role || ''" [reportTypes]="reportTypes"></app-report-view-by-type>
</ng-template>
</div>

</div>

